import React from 'react';
// TODO: JFP-2824 | Suppressed to enable upgrade to ESLint v9 - please fix this if you can!

import { useLoomTouchpointWithProjectType } from '@jira/issue__loom-videos/src/use-loom-touchpoint-with-project-type/index.tsx';
// eslint-disable-next-line jira/restricted/@atlaskit+analytics-next
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { useLoomTouchpointVariant } from '@atlassian/jira-loom-utils/src/controllers/use-loom-touchpoint-variant/index.tsx';
import { LoomTouchpointVariant } from '@atlassian/jira-loom-utils/src/controllers/use-loom-touchpoint-variant/types.tsx';
import { LoomRecorderLoadingBlanket } from '@atlassian/jira-loom-utils/src/ui/loom-recorder-loading-blanket/index.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import { useLoomSupportedProjectType } from '@atlassian/jira-loom-jsm-agent-response/src/controllers/use-loom-supported-project-type/index.tsx';
import { LoomCoUsePanel } from './co-use/index.tsx';

// Loom panel that launched with M2.5
const LoomPanelOld = () => {
	const { loomTouchpointVariant } = useLoomTouchpointWithProjectType();
	if (loomTouchpointVariant === LoomTouchpointVariant.NONE) {
		return null;
	}
	return (
		<AnalyticsContext
			data={{
				attributes: {
					loomTouchpointVariant,
				},
			}}
		>
			<LoomCoUsePanel />
			<LoomRecorderLoadingBlanket />
		</AnalyticsContext>
	);
};

// Feature gated Loom panel component for Loom JSM agent experiment
const LoomPanelWithJSM = () => {
	const { loomTouchpointVariant } = useLoomTouchpointVariant();
	const { showCoUsePanel, showLoadingBlanket } = useLoomSupportedProjectType();
	if (
		loomTouchpointVariant === LoomTouchpointVariant.NONE ||
		(!showCoUsePanel && !showLoadingBlanket)
	) {
		return null;
	}
	return (
		<AnalyticsContext
			data={{
				attributes: {
					loomTouchpointVariant,
					showLoomCoUsePanel: showCoUsePanel,
					showLoomLoadingBlanket: showLoadingBlanket,
				},
			}}
		>
			{showCoUsePanel && <LoomCoUsePanel />}
			{showLoadingBlanket && <LoomRecorderLoadingBlanket />}
		</AnalyticsContext>
	);
};

export const LoomPanel = componentWithFG(
	'loom_jsm_experiment_controller',
	LoomPanelWithJSM,
	LoomPanelOld,
);
